import { StoreState, UserProfileFields } from '../types';
import { Epic, combineEpics } from 'redux-observable';
import { firebaseStorage, firebaseAuth, emailProvider, getCurrentProviderId } from '../firebase';
import { createTryActionsEpic } from './Common';
import _ from 'lodash';
import { UserAction, UPDATE_USER_PROFILE } from '../actions/UserActions';

const updateUserProfile = async ({ displayName, photoFile, password }: UserProfileFields) => {
    const user = firebaseAuth.currentUser;

    if (!user || !user.uid) {
        throw new Error('Tried to update user profile without authenticating');
    }

    // save photo to storage and get URL
    let photoUrl = '';
    let savePhotoURL = false;
    if (photoFile && photoFile.name) {
        const ext = _.last(photoFile.name.split('.'));
        if (ext) {
            const ref = firebaseStorage.ref().child(`users/${user.uid}/images/profile.${ext}`);
            const snapshot = await ref.put(photoFile);
            photoUrl = await snapshot.ref.getDownloadURL();
            savePhotoURL = true;
        }
    } else if (photoFile === null) {
        savePhotoURL = true; // delete photoFile if null
    }

    await user.updateProfile({
        displayName: displayName || user.displayName,
        photoURL: savePhotoURL ? photoUrl : user.photoURL
    });

    if (!!password && getCurrentProviderId(user) === emailProvider.providerId) {
        await user.updatePassword(password);
    }
};

const updateUserProfileEpic: Epic<UserAction, UserAction, StoreState> =
    createTryActionsEpic(
        UPDATE_USER_PROFILE,
        (a, s) => updateUserProfile(a.value),
        (a, r) => a.value);

export default combineEpics<UserAction, UserAction, StoreState>(updateUserProfileEpic);
